<template>
    <q-btn-dropdown split class="btn-dropdown" color="secondary" :label="mainButonLabel"
        :disable-main-btn="rowsSelected === 0" @click="onMainClick" data-testid="main-drop-downburron-jde-status">
        <q-list>
            <q-item clickable v-close-popup @click="(() => onItemClick('sendMeasureament'))" data-testid="SEND_MEASUREAMENT">
                <q-item-section avatar>
                    <q-avatar size="md" icon="mdi-email" color="secondary" text-color="white" />
                </q-item-section>
                <q-item-section>
                    <q-item-label class="btn-title">{{ $gettext('SEND_MEASUREAMENT').toUpperCase() }}</q-item-label>
                </q-item-section>
            </q-item>
            <q-item clickable v-close-popup @click="(() => onItemClick('changeJdeStatus'))" data-testid="CHANGE_STATUS_JDE">
                <q-item-section avatar>
                    <q-avatar size="md" icon="mdi-pencil" color="secondary" text-color="white" />
                </q-item-section>
                <q-item-section>
                    <q-item-label class="btn-title">{{ $gettext('CHANGE_JDE_STATUS').toUpperCase() }}</q-item-label>
                </q-item-section>
            </q-item>
        </q-list>
    </q-btn-dropdown>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import actions from '../constants/billingOrderButtonsAction.js'
import BillingOrderActionButtonsState from '../state/BillingOrderActionButtonsState.js'
@Component({

  props: {
    rowsSelected: {
      type: Number
    }
  }

})
class BIllingOrderDropdownButton extends Vue {
    mainButonLabel = ''
    billingOrderActionButtonsState = BillingOrderActionButtonsState.getInstance();
    buttonsActions = {
      sendMeasurement: {
        action: 'billingOrder.sendMeasurement',
        name: 'btSendMeasurement'
      },
      updationJdeStatus: {
        action: 'billingOrder.updateJdeStatus',
        name: 'updateJdeStatus'
      }
    }

    mounted () {
      this.getMainButtonName(this.billingOrderActionButtonsState.action)
    }

    onItemClick (button) {
      this.getMainButtonName(button)
      this.billingOrderActionButtonsState.setAction(button)
      this.$emit('action-change', button)
    }

    getMainButtonName (action) {
      if (action === actions.CHANGE_JDE_STATUS) {
        this.mainButonLabel = this.$gettext('CHANGE_JDE_STATUS')
      }
      if (action === actions.SEND_MEASUREAMENT) {
        this.mainButonLabel = this.$gettext('SEND_MEASUREAMENT')
      }
    }

    onMainClick () {
      this.$emit('on-main-click', this.getButtoAction())
    }

    getButtoAction () {
      if (actions.CHANGE_JDE_STATUS === this.billingOrderActionButtonsState.action) {
        return this.buttonsActions.updationJdeStatus
      }
      if (actions.SEND_MEASUREAMENT === this.billingOrderActionButtonsState.action) {
        return this.buttonsActions.sendMeasurement
      }
    }
}
export default BIllingOrderDropdownButton
</script>
<style scoped>
.btn-title {
    font-weight: 500;
}

.btn-dropdown {
    margin: 0;
}
</style>
